import { useCallback } from "react";
import { useTranslation } from "react-i18next";

type ArticleNumberRow = {
  label: string;
  value: string;
};

type ProductArticleNumber = {
  articleNumber: string;
  connectionArticleNumber: string;
  localArticleNumber: string;
  otherArticleNumber: string;
};

export function useGetArticleNumbers() {
  const { t } = useTranslation("product", { keyPrefix: "articleNumbers" });
  return useCallback(
    (product: ProductArticleNumber) =>
      [
        product.articleNumber && {
          label: t("default"),
          value: product.articleNumber,
        },
        product.connectionArticleNumber && {
          label: t("connectionArticleNumber"),
          value: product.connectionArticleNumber,
        },
        product.localArticleNumber && {
          label: t("localArticleNumber"),
          value: product.localArticleNumber,
        },
        product.otherArticleNumber && {
          label: t("otherArticleNumber"),
          value: product.otherArticleNumber,
        },
      ].filter((item): item is ArticleNumberRow => !!item),
    [t],
  );
}
